
import { 
  User,
} from "@models";

export class UserLoginClass {
  user: User | null = null;
}